import { parsePhoneForApi, validatePhoneValue } from "@/utils/phoneInput";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const ENQUIRY_TYPES = [
  "General Enquiry",
  "Holiday Package",
  "Activity Booking",
  "Flight Booking",
  "Stays Booking",
  "Visa Enquiry",
  "Other",
];

export function validateContactForm(form, file = null) {
  const errors = {};

  if (!form.fullName?.trim()) errors.fullName = "Full name is required";

  if (!form.email?.trim()) errors.email = "Email is required";
  else if (!EMAIL_RE.test(form.email.trim())) errors.email = "Enter a valid email";

  const phoneError = validatePhoneValue(form.phone);
  if (phoneError) errors.phone = phoneError;

  if (!form.enquiryType) errors.enquiryType = "Please select an enquiry type";
  if (!form.message?.trim()) errors.message = "Message is required";

  if (file && file.size > MAX_FILE_SIZE_BYTES) {
    errors.file = "File size should not exceed 5 MB.";
  }

  return errors;
}

export function buildContactFormData(form, { url = "", file = null } = {}) {
  const parsedPhone = parsePhoneForApi(form.phone);
  if (!parsedPhone) return null;

  const formData = new FormData();

  formData.append("FullName", form.fullName.trim());
  formData.append("Email", form.email.trim());
  formData.append("CountryCode", parsedPhone.countryCode);
  formData.append("PhoneNumber", parsedPhone.phoneNo);
  formData.append("EnquiryType", form.enquiryType);
  formData.append("Message", form.message.trim());
  formData.append("CurrentPageUrl", url || "");

  if (file) {
    formData.append("File", file);
  }

  return formData;
}
